export const preCustomerRegistrationState = {
  loading: false,
  listPreCustomerRegistration: [],
  searchTerm: '',
  sectionsModels: [],
  formModels: {},
  fetchingAddPreCustomerRegistration: false,
  addPreCustomerRegistrationError: null,
  fetching: {
    getPreCustomerRegistration: false,
    deletePreCustomerRegistration: false,
    addPreCustomerRegistration: false,
    updatePreCustomerRegistration: false,
    deletePreCustomerRegistration: false,
  }
}; 